import { computed } from 'vue'
import store from '../store'
import abilities from './abilities'

const permissions = computed(() => store.getters['permission/permissions'])
const permissionsByTeam = computed(() => store.getters['permission/permissionsByTeam'])
const activeTeamId = computed(() => store.getters['permission/activeTeamId'])

const teamSpecificPermissions = computed(() => new Set(abilities.TEAM_SPECIFIC || []))

const normalizePermissions = (list) => (Array.isArray(list) ? list : [])

const globalPermissions = computed(() => {
    const globalTeam = (permissionsByTeam.value || []).find(
        (team) => team?.team_id === 'global_team' || team?.team_type === 'global'
    )

    if (globalTeam?.permissions?.length) {
        return globalTeam.permissions
    }

    return normalizePermissions(permissions.value)
})

const normalizeTeamId = (value) => {
    if (value === null || value === undefined) {
        return null
    }
    return `${value}`
}

const resolveTeamPermissions = (teamId) => {
    const targetId = normalizeTeamId(teamId)
    if (!targetId) {
        return []
    }

    const team = (permissionsByTeam.value || []).find((entry) => {
        const groupId = normalizeTeamId(entry?.group_id)
        const entryTeamId = normalizeTeamId(entry?.team_id)
        return groupId === targetId || entryTeamId === targetId
    })

    return normalizePermissions(team?.permissions)
}

const teamPermissions = computed(() => resolveTeamPermissions(activeTeamId.value))

const anyTeamPermissions = computed(() => {
    const merged = new Set()

    normalizePermissions(globalPermissions.value).forEach((permission) => {
        if (permission) {
            merged.add(permission)
        }
    })

    normalizePermissions(permissionsByTeam.value).forEach((team) => {
        normalizePermissions(team?.permissions).forEach((permission) => {
            if (permission) {
                merged.add(permission)
            }
        })
    })

    return [...merged]
})

export function useHasAbility() {
    function resolvePermissionList(permissionName, teamId = null) {
        if (teamSpecificPermissions.value.has(permissionName)) {
            const targetTeamId = teamId || activeTeamId.value

            if (targetTeamId) {
                const teamPerms = resolveTeamPermissions(targetTeamId)
                if (teamPerms.length > 0) {
                    return teamPerms
                }
                return globalPermissions.value
            }

            return anyTeamPermissions.value
        }

        return globalPermissions.value
    }

    function can(permissionName = null, teamId = null){
        let access = false
        if(!permissionName || permissionName?.length === 0 ){
            access = true
        }else{
            if(Array.isArray(permissionName)){
                if(permissionName.length === 0){
                    access = true
                }
                for(let perm of permissionName){
                    if(!perm){
                        access = true
                    }else if(!access){
                        const permissionList = resolvePermissionList(perm, teamId)
                        access = Array.isArray(permissionList) && permissionList.indexOf(perm) !== -1
                    }
                }
            }else {
                const permissionList = resolvePermissionList(permissionName, teamId)
                access = Array.isArray(permissionList) && permissionList.indexOf(permissionName) !== -1
            }
        }

        return access
    }

    function accessMenu(permissionNames){
        return can(permissionNames)
    }
    return { can,accessMenu }
  }
